import { createActionGroup, emptyProps } from '@ngrx/store';

export const ModalsActions = createActionGroup({
  source: 'Modals Actions',
  events: {
    'Dismiss All': emptyProps,
  },
});
